/**
 * @license Copyright 2019 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
 */

.page-header {
  position: fixed;
  height: var(--page-header-height);
  width: 100vw;

  background: var(--highlighted-background-color);
  border-bottom: 1px solid var(--base-border-color);

  display: flex;
  flex-direction: row;
  align-items: center;
  z-index: 10;
}

.page-header > div {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.page-header__left {
  height: var(--page-header-height);
  width: var(--page-header-height);
  flex-shrink: 0;

  border-right: 1px solid var(--base-border-color);
}

.page-header__center {
  height: var(--page-header-height);
  width: calc(100% - var(--page-header-height) * 2);
}

.page-header__sidebar-button {
  cursor: pointer;
  /* Material Icons aren't actually vertically centered for their line-height, so adjust it */
  position: relative;
  top: 2px;
}

.page-header__right {
  height: var(--page-header-height);
  width: var(--page-header-height);
  flex-shrink: 0;
}

.page-header__right--with-content {
  border-left: 1px solid var(--base-border-color);
}
